module.exports = __webpack_public_path__ + "img/diving.9034321f450317e51447df3018aa00bb.jpg";